import React, { Component } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import MonthlyConversation from './monthlyReports/MonthlyConversation';
import { ToastContainer, toast } from "react-toastify";
import $ from 'jquery';
import Conversation from './conversationStat/Conversations';
import QueriesServed from './conversationStat/QueriesServed';
import UserEngagement from './conversationStat/UserEngagement';
import AvgQueriesServed from './conversationStat/AvgQueriesServed';
import DailyReportTab from './dailyReports/DailyReportTab';
import WeeklyConData from './weeklyReports/WeeklyConvData';
import OutputSpreadsheet from './OutputSpreadsheet';
import Summary from './Summary';

class Statistics extends Component {
    componentDidMount() {
        (function () {
            var currentPath = window.location.href;
            var currentPath = window.location.href;
            var path = window.origin + "/platform/projectmgmt/reports";
            var path1 = window.origin + "/platform/projectmgmt/reports/";
            if (currentPath === path || currentPath === path1) {
                $("#summary").addClass('active');
            } else if (currentPath.includes('/statistics/dailyConvdata')) {
                $("#daily-reports").addClass('active');
            } else if (currentPath.includes('/statistics/monthlyconvdata')) {
                $("#monthly-conv-data").addClass('active');
            } else if (currentPath.includes('/statistics/weeklyconvdata')) {
                $("#weekly-conv-data").addClass('active');
            } else if (currentPath.includes('/statistics/output-spreadsheet')) {
                $("#output-spreadsheets").addClass('active');
            }
            else {
                $("#" + localStorage.getItem("last-used-report-tab")).addClass('active')
            }

            $("#daily-reports,#monthly-conv-data,#weekly-conv-data,#output-spreadsheets,#summary")
                .on("click", function () {
                    $("#daily-reports,#monthly-conv-data,#weekly-conv-data,#output-spreadsheets,#summary")
                        .removeClass('active');
                    localStorage.setItem("last-used-report-tab", $(this)[0].id);
                    $(this).addClass('active')
                })

            $("#daily-reports").on("click", function () {
                $("#daily-conv-data,#daily-perform-data")
                    .removeClass('active');
                $("#daily-conv-data").addClass('active');
            })

        })();
    }


    render() {

        return (
            <div className="container-fluid">
                {/* for toaster */}
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />


                <div className="row">
                    <div className="container-fluid" >
                        {/* Nav tabs */}
                        <div className="tab-class">
                            <ul className="nav nav-tabs navCluster">
                                <Link to="/projectmgmt/reports" className="nav-item"
                                    style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="summary">
                                        Summary
                                    </li></Link>
                                <Link to="/projectmgmt/reports/statistics/dailyConvdata" className="nav-item"
                                    style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="daily-reports">
                                        Daily Reports
                                    </li></Link>
                                <Link to="/projectmgmt/reports/statistics/weeklyconvdata" className="nav-item"
                                    style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="weekly-conv-data">
                                        Weekly Reports
                                    </li>
                                </Link>
                                <Link to="/projectmgmt/reports/statistics/monthlyconvdata" className="nav-item"
                                    style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="monthly-conv-data">
                                        Monthly Reports
                                    </li>
                                </Link>
                                <Link to="/projectmgmt/reports/statistics/output-spreadsheet" className="nav-item"
                                    style={{ textDecoration: 'none' }}>
                                    <li className="nav-link" id="output-spreadsheets">
                                        Output Spreadsheets
                                    </li>
                                </Link>
                            </ul>
                        </div>
                    </div>
                </div>
                <Switch>
                    <Route path="/projectmgmt/reports/statistics/output-spreadsheet" component={OutputSpreadsheet}></Route>
                    <Route path="/projectmgmt/reports/statistics/weeklyconvdata" component={WeeklyConData}></Route>
                    <Route path="/projectmgmt/reports/statistics/monthlyconvdata" component={MonthlyConversation}></Route>
                    <Route path="/projectmgmt/reports/statistics/dailyConvdata" component={DailyReportTab}></Route>
                    <Route path="/projectmgmt/reports" component={Summary}></Route>
                </Switch>
            </div>
        );
    }
}

export default Statistics;


// WEBPACK FOOTER //
// ./src/projectmgmt/reports/statistics/Statistics.js